import React, { useState, useEffect } from "react";
import _ from "lodash";
import { If } from "react-condition";
import slugify from "slugify";

function TextTable({ data }) {
  const [element, setElement] = useState({
    type: "texttable",
    properties: {
      label: "Text Table question field.",
      options: [],
      addMore: false,
      rows: 3,
    },
    required: false,
  });

  useEffect(() => {
    setElement(data);
  }, [data]);

  function onClickAddMore(event) {
    let d = {
      type: element.type,
      properties: {
        label: element.properties.label,
        options: element.properties.options,
        rows: parseInt(element.properties.rows) + 1,
        addMore: element.properties.addMore,
      },
      required: element.required,
    };
    setElement(d);
  }

  return (
    <div className="form-group col-md-3 mb-3 form-builder-element">
      <label htmlFor="">
        {element.properties.label}
        <If test={element.required === true}><span style={{color:'red'}}>*</span></If>
      </label>

      <table className="table table-striped">
        <thead>
          <tr>
            {element.properties.options.map((v, k) => (
              <th key={k}>{v}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {_.times(element.properties.rows).map((i, e) => (
            <tr key={e}>
              {element.properties.options.map((v1, k1) => (
                <td key={k1}>
                  <input
                    type="text"
                    className="form-control form-view"
                    data={JSON.stringify(element)}
                    row={i}
                    total-rows={element.properties.rows}
                    column={v1}
                    label={element.properties.label}
                    name={slugify(element.properties.label)}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <If test={element.properties.addMore === true}>
        <div style={{ height: "40px" }}>
          <button className="btn btn-link float-right" onClick={onClickAddMore}>
            Add More
          </button>
        </div>
      </If>
    </div>
  );
}

export default TextTable;
